<section class="snackbar">
  <article>
    <div class="title" matSnackBarLabel>
      <mat-icon>error</mat-icon> {{ data.title }}
    </div>
    <div class="message">
      {{ data.message }}
    </div>
  </article>
  <button mat-icon-button matSnackBarAction type="button" (click)="snackBarRef.dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</section>
